import JsSdkModel from './jsSdk';

export default JsSdkModel;
